import axios from 'axios'

export default {
  async generateOtp(payload) {
    return axios.post(`/auth/generate-otp`, payload)
  },

  async loginWithEmail({ email, code }) {
    return axios.post(`/auth/login-with-email`, { email, OTP: code })
  },

  async loginWithSocial(payload) {
    return axios.post(`/auth/login-with-social`, payload)
  }
}
